<script setup lang="ts">
import { nextTick, ref, useTemplateRef } from 'vue';
import { useEventListener, useWindowSize } from '@vueuse/core';
import { Search as SearchIcon } from 'lucide-vue-next';
import Favorites from '@/components/Favorites.vue';
import Search from '@/components/Search.vue';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { SidebarTrigger } from '@/components/ui/sidebar';
import User from '@/components/User.vue';

const mobileSearch = useTemplateRef('mobileSearch');
const { width } = useWindowSize();
const open = ref(false);

useEventListener('popstate', onPopstate);

function onPopstate() {
    open.value = false;
}

function onOpen(isOpen: boolean) {
    if (isOpen) {
        history.pushState({}, '');
        nextTick(() => mobileSearch.value?.focus());
    } else {
        history.back();
    }
}
</script>

<template>
    <div
        class="bg-background sticky top-0 z-20 flex h-18 items-center justify-between gap-x-4 px-6 py-4"
    >
        <SidebarTrigger class="lg:hidden" />
        <Dialog
            v-if="width <= 480"
            v-model:open="open"
            @update:open="onOpen"
        >
            <DialogTrigger as-child>
                <Button
                    variant="ghost"
                    class="mr-auto"
                >
                    <SearchIcon />
                </Button>
            </DialogTrigger>
            <DialogContent
                class="top-10 border-0 p-0"
                :show-close-button="false"
            >
                <Search ref="mobileSearch" />
            </DialogContent>
        </Dialog>
        <Search v-else />
        <ul class="flex gap-x-1">
            <!--            <li><Notifications /></li>-->
            <li><Favorites /></li>
            <li><User /></li>
        </ul>
    </div>
</template>
